import {ListView} from '@github-ui/list-view'
import {ListViewMetadata} from '@github-ui/list-view/ListViewMetadata'
import {SkeletonBox} from '@primer/react/experimental'

import styles from './ReposListLoadingSkeleton.module.css'

export function ReposListLoadingSkeleton() {
  const title = (
    <>
      <span className="sr-only">Loading repositories</span>
      <SkeletonBox width="80px" height="20px" />
    </>
  )

  const metadata = (
    <ListViewMetadata title={title}>
      <SkeletonBox width="120px" height="32px" />
    </ListViewMetadata>
  )

  return (
    <div className="pr-my-3">
      <div data-hpc />
      <div className={styles.reposListContainer}>
        <ListView metadata={metadata} title="Loading repositories" titleHeaderTag="h2">
          {Array.from({length: 5}).map((_, i) => (
            <li key={`${i}`}>
              <div className={styles.skeletonItem}>
                <div className={styles.skeletonHeader}>
                  <SkeletonBox width="20px" height="20px" />
                  <SkeletonBox width="60%" height="20px" />
                </div>
                <div className={styles.skeletonDescription}>
                  <SkeletonBox width="80%" height="16px" />
                </div>
                <div className={styles.skeletonMetadata}>
                  <SkeletonBox width="80px" height="16px" />
                  <SkeletonBox width="80px" height="16px" />
                  <SkeletonBox width="80px" height="16px" />
                </div>
              </div>
            </li>
          ))}
        </ListView>
      </div>
    </div>
  )
}
